module.exports = __webpack_public_path__ + "img/search.3112e3ed.svg";